import React from "react";
import "./App.css";

import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import { Outlet } from "react-router-dom";

const App = React.memo(() => {
  return (
    <>
      {/* Header Start */}
      <Navbar />
      {/* Header End */}

      <Outlet />

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
});

export default App;
